import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { isEmpty } from "lodash";

import { DialogFooter } from "../../components/DialogFooter";
import { useInHomeVisitModalsDataContext } from "../../ShiftDiscovery/useInHomeVisitModalsDataContext";
import { VisitPayInfoLabel } from "../Card/PayInfoLabel";
import { useGetWorkerVisitLockStatus } from "../useGetWorkerVisitLockStatus";
import { AccessLockedButton } from "./AccessLockedButton";
import { BookVisitButton } from "./BookVisitButton";

export function VisitBottomSheetFooter() {
  const { visit, case: caseData, isVisitLoading } = useInHomeVisitModalsDataContext();
  const { userId: workerId } = useDefinedWorker();

  const { data: lockResponse } = useGetWorkerVisitLockStatus(workerId);
  const lockedByWorkplaceId = lockResponse?.data?.attributes.lockedByWorkplaceId;

  const disableBooking = !isDefined(visit) || !isEmpty(visit.attributes.missingRequirements);

  return (
    <DialogFooter withShadow orientation="vertical">
      <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
        {isDefined(visit) && <VisitPayInfoLabel visit={visit} wrapperSx={{ pl: 5 }} />}
        {isDefined(visit) &&
          (isDefined(lockedByWorkplaceId) ? (
            <AccessLockedButton lockedByWorkplaceId={lockedByWorkplaceId} />
          ) : (
            <BookVisitButton
              visitId={visit.id}
              caseId={caseData?.id}
              isLoading={isVisitLoading}
              isMissingRequirements={disableBooking}
            />
          ))}
      </Stack>
    </DialogFooter>
  );
}
